import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { useStrapiAuthContext } from "../contexts/StrapiV3Auth";

const Firma = ({ match }) => {
  const [colaboradores, setColaboradores] = useState([]);
  const [imagenColaboradores, setImagenColaboradores] = useState([]);
  const [pieDeFirma, setPieDeFirma] = useState();
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  const { slug } = useParams();

  const { token } = useStrapiAuthContext();

  useEffect(() => {
    if (token && slug) {
      setLoading(true);
      setNotFound(false);
      // En Strapi v3, buscar por slug usando query parameter
      axios
        .get(`${process.env.REACT_APP_URL_API}/colaboradores?slug=${slug}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          if (res.data && res.data.length > 0) {
            setColaboradores(res.data[0]);
            setImagenColaboradores(res.data[0].Imagen);
            setNotFound(false);
          } else {
            console.error(`No se encontró colaborador con slug: ${slug}`);
            setNotFound(true);
          }
        })
        .catch((err) => {
          console.error("Error al obtener colaborador:", err);
          console.error("URL intentada:", `${process.env.REACT_APP_URL_API}/colaboradores?slug=${slug}`);
          setNotFound(true);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [token, slug]);
  const mail = "mailto:" + colaboradores.Email;
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_URL_API}/institucional`).then((res) => {
      setPieDeFirma(res.data.Pie_de_firma);
    });
  }, []);

  if (!token || loading) {
    return (
      <div style={{ padding: 24, fontFamily: "Montserrat, sans-serif" }}>
        Cargando…
      </div>
    );
  }

  if (notFound) {
    return (
      <div style={{ padding: 24, fontFamily: "Montserrat, sans-serif" }}>
        <h2>Firma no encontrada</h2>
        <p>No existe una firma para: <strong>{slug}</strong></p>
      </div>
    );
  }

  return (
    <>
      <table border="0" cellpadding="0" width="600">
        <tbody border="0">
          <tr border="0">
            <td rowSpan="8" style={{ width: "120px" }}>
              <div
                style={{
                  borderRadius: "50%",
                  overflow: "hidden!important",
                  msoHide: "all",
                  display: "-webkit-inline-box",
                  height: "120px",
                }}
              >
                <img
                  src={imagenColaboradores.url}
                  width="120"
                  height="120"
                  alt=""
                  style={{
                    borderRadius: "50%",
                    position: "relative",
                    top:
                      colaboradores.Proyectos === "Sales" &&
                      pieDeFirma?.webinarStatus
                        ? -24
                        : 0,
                    left: 2,
                  }}
                ></img>
              </div>
            </td>
            <td rowSpan="8">
              <span>&nbsp;&nbsp;&nbsp;</span>
            </td>
            <td style={{ paddingBottom: "0px" }} rowSpan={1}>
              <span
                style={{
                  color: "#2E2D31",
                  fontFamily: "Open Sans, Tahoma, Verdana",
                  fontSize: "16px",
                  marginBottom: "0px",
                  fontWeight: "700",
                  marginBlockStart: "1px !important",
                  marginBlockEnd: "0em !important",
                  marginLeft: "5px",
                  lineHeight: "18px",
                }}
              >
                {colaboradores.Nombre}
              </span>
              <br></br>
              <span
                style={{
                  paddingBottom: " 2px",
                  marginTop: "2px",
                  fontFamily: " Open Sans, Tahoma, Verdana",
                  fontSize: "12px",
                  margiBottom: "0px",
                  color: "#2E2D31",
                  marginBlockStart: " 0em !important",
                  marginBlockEnd: " 0em !important",
                  marginLeft: "5px",
                  lineHeight: "16px",
                }}
              >
                {colaboradores.Puesto}
              </span>
            </td>
          </tr>
          <tr>
            <td
              style={{
                paddingBottom: "0px",
                fontSize: "0px",
              }}
              rowSpan="1"
            >
              <span
                style={{
                  margin: "0px",
                  fontSize: "10px",
                  fontFamily: "Open Sans, Tahoma, Verdana",
                  textDecoration: "none",
                  color: "#2E2D31 !important",
                  fontWeight: " normal !important",
                  marginLeft: "5px",
                  lineHeight: "15px",
                }}
              >
                T:
                <a
                  style={{
                    boxSizing: "border-box",
                    color: "rgba(46,45,49,1)",
                    textDecoration: "none",
                    fontSize: "10px",
                    fontFamily: "Open Sans, Tahoma, Verdana",
                    lineHeight: "15px",
                  }}
                  href={colaboradores.Telefono}
                >
                  {colaboradores.Telefono}
                </a>
              </span>
              <span
                style={{
                  margiBottom: "0px",
                  fontSize: "10px",
                  fontFamily: "Open Sans, Tahoma, Verdana",
                  textDecoration: "none",
                  color: "#2e2d31 !important",
                  fontWeight: " normal !important",
                }}
              ></span>
            </td>
          </tr>
          <tr>
            <td
              style={{
                paddingBottom: "0px",
                fontSize: "0px",
              }}
              rowSpan="1"
            >
              <p
                style={{
                  margin: "0px",
                  fontSize: "10px",
                  fontFamily: "Open Sans, Tahoma, Verdana",
                  textDecoration: "none",
                  color: "#2E2D31 !important",
                  fontWeight: "normal !important",
                  marginLeft: "5px",
                  lineHeight: "15px",
                }}
              >
                E:
                <a
                  style={{
                    fontSize: "10px",
                    fontFamily: "Open Sans, Tahoma, Verdana",
                    textDecoration: "underline",
                    color: "#0449C0",
                  }}
                  href={mail}
                >
                  {colaboradores.Email}
                </a>
              </p>
            </td>
          </tr>
          <tr>
            <td
              style={{
                paddingBottom: "0px",
                fontSize: "0px",
              }}
              rowSpan="1"
            >
              <span
                style={{
                  fontSize: "10px",
                  fontFamily: "Open Sans, Tahoma, Verdana",
                  textDecoration: "none",
                  color: "#2E2D31 !important",
                  fontWeight: " normal !important",
                  marginLeft: "5px",
                }}
              >
                A:{" "}
              </span>
              <span
                style={{
                  fontSize: "10px",
                  fontFamily: "Open Sans, Tahoma, Verdana",
                  textDecoration: "none",
                  color: "#2E2D31",
                  lineHeight: "15px",
                }}
              >
                {colaboradores.Direccion}
              </span>
            </td>
          </tr>
          <tr style={{ height: "32px" }}>
            <td rowSpan="1">
              <a
                href="https://www.possumus.tech/"
                style={{ marginRight: "15px" }}
              >
                <img
                  src={`${process.env.REACT_APP_URL_API}/uploads/new_Possumus_logo_2_b9a6ed7450.png`}
                  width="113"
                  alt=""
                ></img>
              </a>

              <a
                title="LinkedIn"
                href="https://www.linkedin.com/company/possumustech/"
              >
                <img
                  src={`${process.env.REACT_APP_URL_API}/uploads/round_back_ICO_IN_2_a7239b48dc.png`}
                  width="22"
                  alt=""
                ></img>
              </a>
              <a
                title="Instagram"
                href="https://www.instagram.com/possumus.tech/"
              >
                <img
                  src={`${process.env.REACT_APP_URL_API}/uploads/round_back_ICO_IG_2_9ef0e79b99.png`}
                  alt="Instagram"
                  width="22"
                ></img>
              </a>
              <a
                title="facebook"
                href="https://www.facebook.com/possumus.tech/"
              >
                <img
                  src={`${process.env.REACT_APP_URL_API}/uploads/round_back_ICO_FB_2_64b5ffefda.png`}
                  alt="Facebook"
                  width="22"
                ></img>
              </a>
              <a title="twitter" href="https://twitter.com/PossumusTech">
                <img
                  src={`${process.env.REACT_APP_URL_API}/uploads/round_back_ICO_TW_2_6c9cf1a04c.png`}
                  alt="Twitter"
                  width="22"
                ></img>
              </a>
            </td>
          </tr>
          {colaboradores.Proyectos === "Sales" &&
            (pieDeFirma?.webinarStatus ? (
              <tr>
                {pieDeFirma ? (
                  <a href={pieDeFirma?.enlace} target="_blank" rel="noreferrer">
                    <img src={pieDeFirma?.imagen.url} alt="Possumus"></img>
                  </a>
                ) : (
                  <span className="visually-hidden">Cargando...</span>
                )}
              </tr>
            ) : (
              <tr></tr>
            ))}
        </tbody>
      </table>
    </>
  );
};

export default Firma;
